var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.element,{tag:"component"},[_vm._t("filter"),_vm._t("body",function(){return [_vm._l((_vm.hits.items),function(hit,index){return [_vm._t("default",null,{"hit":hit,"index":index,"pageTotal":_vm.hits.items.length})]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }